/**
 * Loại chương trình mục tiêu
 */
export default {
  /**
   * CTMT
   */
  Target: 1,

  /**
   * Dự án
   */
  Project: 2,
};
